import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { trackingQueries } from '@as-react/common-queries';
import { useQuery } from '@tanstack/react-query';
import { Grid, StackBlock, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { ServiceOrderTrackingDetails } from '../components/service-order-tracking/ServiceOrderTrackingDetails';
import { ServiceOrderTrackingOverview } from '../components/service-order-tracking/ServiceOrderTrackingOverview';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { useQueryStringParams } from '../hooks/useQueryStringParams';
const OrderTrackingContainer = () => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const { servicesEndpoint } = useAemConfig();
    const hash = useQueryStringParams('serviceOrder');
    const { getDetails, getTimeline } = trackingQueries({ servicesEndpoint });
    const { data: details, error: detailsError } = useQuery(Object.assign(Object.assign({}, getDetails({ hash })), { enabled: !!hash }));
    const { data: timeline, error: timelineError } = useQuery(Object.assign(Object.assign({}, getTimeline({ hash })), { enabled: !!hash }));
    if (detailsError || timelineError) {
        return (_jsxs(StackBlock, { gap: "8", children: [_jsx(TextAlpha, { variant: "headingL", alignment: "center", children: t('tracking.order.not.found.title') }), _jsx(TextAlpha, { variant: "bodyM", color: "brand", alignment: "center", children: t('tracking.order.not.found.message') })] }));
    }
    if (!details || !timeline) {
        return null;
    }
    return (_jsxs(Grid, { columns: { base: 1, xl: 3 }, children: [_jsx(Grid.Cell, { display: "flex", children: _jsx(ServiceOrderTrackingOverview, { serviceOrder: details }) }), _jsx(Grid.Cell, { span: 2, children: _jsx(ServiceOrderTrackingDetails, { serviceOrder: details, timeline: timeline }) })] }));
};
export default OrderTrackingContainer;
